import { useCallback, useEffect, useState } from 'preact/hooks'
import Icon from 'snippets/icon/icon'

const useMessage = () => {
  const [message, setMessage] = useState(null)
  const [duration, setDuration] = useState(null)

  const clearMessage = () => {
    setMessage(null)
  }

  const markupMessage = (text, content, noticeClass, customIcon) => (
    <div className={`notice-main relative ${noticeClass}`}>
      {customIcon && (
        <button type="button" className="notice-main-icon" aria-label="icon notice">
          {customIcon}
        </button>
      )}
      {(text || content) && (
        <>
          <div className="notice-main-content">
            {text && <h4 className="mb-2">{text}</h4>}
            {content && <p>{content}</p>}
          </div>
          <button
            type="button"
            aria-label="icon close"
            className="notice-main-close m-auto mr-0 pr-4"
            onClick={clearMessage}
          >
            <Icon className="size-4 text-white" name="icon-close" />
          </button>
        </>
      )}
    </div>
  )

  const renderMessage = (text, content = '', type = 'standard', customDuration = 5000) => {
    if (!text && !content) {
      return ''
    }

    if (customDuration) {
      setDuration(customDuration)
    }

    let noticeClass = ''
    let customIcon = ''

    switch (type) {
      case 'success':
        noticeClass = 'notice-main-success'
        customIcon = <Icon className="size-4" name="icon-success-circle" />
        break
      case 'warning':
        noticeClass = 'notice-main-warning'
        customIcon = <Icon className="size-4" name="icon-warning" />
        break
      case 'error':
        noticeClass = 'notice-main-error'
        customIcon = <Icon className="size-4" name="icon-error-circle" viewBox="0 0 16 16" />
        break
      default:
        noticeClass = ''
        customIcon = <Icon className="size-4" name="icon-info-circle" />
        break
    }

    return markupMessage(text, content, noticeClass, customIcon)
  }

  useEffect(() => {
    if (duration) {
      setTimeout(() => {
        setMessage(null)
      }, duration)
    }
  }, [duration])

  const initMessage = useCallback((text, content, type, customDuration) => {
    const messageHTML = renderMessage(text, content, type, customDuration)

    if (messageHTML) {
      setMessage(messageHTML)
    }
  }, [])

  return { message, initMessage, clearMessage }
}

export default useMessage
